<template>
  <layout-main-inner title="配置数据">
    <layout-card-wrap>
      <el-divider>WMS</el-divider>
      <el-row :gutter="20">
        <el-col :md="6">
          <box-code-card
            :config="boxCode"
            :enable="false"></box-code-card>
        </el-col>
        <el-col :md="6">
          <warehouse-management-card
            :config="wm"
            :enable="false"></warehouse-management-card>
        </el-col>
        <el-col :md="6">
          <warehouse-card :config="warehouse"></warehouse-card>
        </el-col>
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import BoxCodeCard from '@/pages/appraisal/base/busi/box-code-card.vue'
import WarehouseManagementCard from '@/pages/appraisal/base/busi/warehouse-management/warehouse-management-card.vue'
import WarehouseCard from '@/pages/appraisal/base/busi/warehouse/warehouse-card.vue'
const imgaePng = require('../../assets/images/cate.png')
export default {
  name: 'WmsConfigPage',
  components: { BoxCodeCard, WarehouseManagementCard, WarehouseCard },
  data() {
    return {
      boxCode: { title: '流转箱码', info: '用于生成流转箱码的生产和下载', image: imgaePng },
      warehouse: { title: '仓库管理', info: '用于管理企业的仓库和库位信息', image: imgaePng },
      wm: { title: '仓管账号', info: '用于管理企业的仓库管理员账号', image: imgaePng, operType: 60, text: '仓管' }
    }
  },
  methods: {}
}
</script>
